import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import ClientProfilePage from '../pages/Client/ClientProfilePage';
import ProtectedRouteV2 from './ProtectedRouteV2';
import MenuAdministrationPage from '../pages/Client/MenuAdministrationPage';

const clientProfileRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    {/* 🔹 Ruta para administración de perfiles */}
    <Route
      path="/client-profiles"
      element={
        <>
          <PageTitle title="Perfiles de Cliente | POS System" />
          <ClientProfilePage />
        </>
      }
    />

    <Route
      path="/client-profiles/administration"
      element={
        <>
          <PageTitle title="Administración de Menús | POS System" />
          <MenuAdministrationPage />
        </>
      }
    />

    {/*
     * "Configuración de Módulos" se movió al menú Configuración:
     * ver settingsRoutes.tsx (/settings/modules).
     */}
  </Route>
);

export default clientProfileRoutes;
